import React, { Component } from "react";

class FeelingProud extends Component {
  render() {
    const theme = this.props.theme;
    const divStyle = {
      backgroundColor: 'materialDarkTheme', // Change the background color
      padding: '20px', // Add some padding
    };
    return (
      <div style={divStyle}>
        <h1>My Research put in Simple Words</h1>
        The goal of my work is to tell a robot what to do and it should do it in an optimal way.
        I am starting with robot manipulators and mobile robots. Let's see where I will end up.
        <h1>My Research in Technical Words</h1>
        I started my research by exploring state-of-the-art temporal logic planners that generate task plans that satisfy a task specification for mobile and manipulator robots, which are then executed with constrained motion controllers that respect joints limits, tilting, and collision avoidance constraints.
        <h1>Projects</h1>
        You are welcome to check out my <a href="https://marcos-pereira.github.io/#/projects" target="_blank">Projects</a> .
        There you can also find my publications and BSc and MSc Thesis.
      </div>
    );
  }
}

export default FeelingProud;
